<div class="col-md-12 padding-top-10 log_sch change_pass">
  <form [formGroup]="changePassword" (ngSubmit)="onChangePassword(changePassword.value)">
      <div style="margin-bottom: 25px" class="input-group">
        <label style="width:200px;">Enter Your Old Password<i class="fa fa-asterisk"></i></label>
        <input id="float-input" type="password" class="ui-inputtext form-control" style="width: 1000; width: 25px;"
        formControlName="strPassword">
      </div>
      <div style="margin-bottom: 25px" class="input-group">
        <label style="width:200px;">Enter Your New Password<i class="fa fa-asterisk"></i></label>
        <input id="float-input" type="password" class="ui-inputtext form-control" style="width: 1000; width: 25px;"
        formControlName="strNewPassword">
      </div>
      <div style="margin-bottom: 25px" class="input-group">
        <label style="width:200px;">Confirm New Password<i class="fa fa-asterisk"></i></label>
        
        <input id="float-input" type="password" class="ui-inputtext form-control" style="width: 1000; width: 25px;"
        formControlName="strConfPassword">
        <span class="input-has-error change_pass-mismatch" *ngIf="changePassword.controls.strConfPassword.errors && changePassword.controls.strConfPassword.errors.mustMatch">
            Password Mismatch!!
        </span>
   
      </div>
      <div class="form-group sub_btn">
          <div class="col-sm-9" style="display: inline">
            <button type="submit" class="btn btn-primary align-right" [disabled]="changePassword.invalid">Change Password</button>
          </div>
        </div>
  </form>
  </div>